import classNames from 'classnames';

import styles from './PreloaderHrtek.module.scss';
import { PreloaderHrtekProps } from './PreloaderHrtek.types';

export function PreloaderHrtek({ active }: PreloaderHrtekProps) {
  return (
    <div
      className={classNames(styles.preloader, {
        [styles.active]: active,
      })}
    >
      <svg
        width="96"
        height="96"
        viewBox="0 0 96 96"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={styles.box}
          d="M0 46.0038C0 24.3135 0 13.4736 6.74202 6.7419C13.484 0.0105314 24.3134 0 46.0038 0H50.0067C71.6865 0 82.5264 1.14441e-06 89.2686 6.7419C96.0105 13.4841 96 24.3135 96 46.0038V50.0067C96 71.6865 96 82.5264 89.2686 89.2686C82.5369 96.0105 71.6865 96 50.0067 96H46.0038C24.3134 96 13.4735 96 6.74202 89.2686C0.0105345 82.5369 0 71.6865 0 50.0067V46.0038Z"
        />
        <path
          className={styles.cube}
          d="M96 50.6722C95.9998 56.5413 95.9944 61.6045 95.8461 66H72.288C67.9868 66 65.8362 66 64.1933 65.1629C62.7483 64.4266 61.5734 63.2517 60.8371 61.8067C60 60.1638 60 58.0132 60 53.712V51.36C60 45.9835 60 43.2953 58.9537 41.2417C58.0333 39.4353 56.5647 37.9667 54.7583 37.0463C52.7047 36 50.0165 36 44.64 36H42.288C37.9868 36 35.8362 36 34.1933 35.1629C32.7483 34.4266 31.5734 33.2517 30.8371 31.8067C30 30.1638 30 28.0132 30 23.712V0.156138C34.5624 0.00085153 39.8453 0 46.0038 0H50.0067C71.6865 0 82.5264 1.14441e-06 89.2686 6.7419C95.9294 13.403 95.9993 24.0535 96 45.2255C96 45.45 96 45.6758 96 45.9028V50.0067C96 50.2297 96 50.4515 96 50.6722Z"
        />
        <path
          className={styles.cube}
          d="M18 71.28C18 74.9914 21.0086 78 24.72 78H39.405C43.1163 78 46.125 74.9914 46.125 71.28V56.595C46.125 52.8837 43.1163 49.875 39.405 49.875H24.72C21.0086 49.875 18 52.8837 18 56.595V71.28Z"
        />
      </svg>
    </div>
  );
}
